export default __webpack_public_path__ + "static/media/wingstop-logo.03ac0bad.jpeg";